var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.imageClass,attrs:{"src":_vm.url,"width":_vm.width,"height":_vm.height,"draggable":"false"},on:{"click":function($event){return _vm.blowUp(_vm.url)},"load":_vm.onLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }